import { toast } from '@/composables/baseToast'

/**Sends a toast with the message and throws an error with the message or throws the provided error.
 *
 * Should be thrown like an error rather than called like a standard function.
 */
export default function (message: string, error?: Error) {
  toast(message, { type: 'error', timeoutMs: 5000 })
  if (error) {
    return error
  } else {
    return new Error(message)
  }
}
